import { render, staticRenderFns } from "./Vocalization.vue?vue&type=template&id=9eab96b8&scoped=true&"
import script from "./Vocalization.vue?vue&type=script&lang=js&"
export * from "./Vocalization.vue?vue&type=script&lang=js&"
import style0 from "./Vocalization.vue?vue&type=style&index=0&id=9eab96b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eab96b8",
  null
  
)

export default component.exports